// Reference: Joyride's library https://github.com/gilbarbara/react-joyride/blob/main/src/modules/dom.js

/**
 * Check if the element is visible
 *
 * @param {HTMLElement} element
 *
 * @returns {boolean}
 */
export function isElementVisible(element) {
  if (!element) return false;
  var parentElement = element;

  while (parentElement) {
    if (parentElement === document.body) break;

    if (parentElement instanceof HTMLElement) {
      var {
        display,
        visibility
      } = getComputedStyle(parentElement);

      if (display === 'none' || visibility === 'hidden') {
        return false;
      }
    }

    parentElement = parentElement.parentNode;
  }

  return true;
}
/**
 * Find and return the target DOM element based on a step's 'target'.
 *
 * @private
 * @param {string|HTMLElement} element
 *
 * @returns {HTMLElement|null}
 */

export function getElement(element) {
  if (typeof element === 'string') {
    return document.querySelector(element);
  }

  return element;
}
//# sourceMappingURL=tourtip.utils.js.map